module.exports = __webpack_public_path__ + "img/logo1.016be6f8.png";